import axios from 'axios';
import moment from 'moment';
import { cookies } from 'static';

const FARM_REGISTERED_ZAPIER_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/14247483/2go0qbs/';

type FarmRegisteredPayload = {
  farmId?: string | number;
  farmName: string;
  orgNumber?: string;
  companyName?: string;
  firstName: string;
  lastName: string;
  address: string;
  city: string;
};

const getStoredEmail = (): string => {
  try {
    const stored = localStorage.getItem(cookies.FarmersPlanToken);
    return stored ? JSON.parse(stored)?.username ?? '' : '';
  } catch {
    return '';
  }
};

/** Fire-and-forget: triggers the Zapier zap that runs when a farm has been registered. */
export const notifyZapierFarmRegistered = async (payload: FarmRegisteredPayload) => {
  try {
    await axios.get(FARM_REGISTERED_ZAPIER_WEBHOOK_URL, {
      params: {
        date: moment().format('YYYY-MM-DD HH:mm:ss'),
        email: getStoredEmail(),
        farmId: payload.farmId != null ? String(payload.farmId) : '',
        farmName: payload.farmName,
        orgNumber: payload.orgNumber ?? '',
        companyName: payload.companyName ?? '',
        firstName: payload.firstName,
        lastName: payload.lastName,
        address: payload.address,
        city: payload.city,
      },
    });
  } catch (error) {
    console.error('Error sending data to Zapier:', error);
  }
};
